export default __webpack_public_path__ + "static/media/Code.c97dbefd.svg";